/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/distribution" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdAudienceDistribution,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/audiences/distribution`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdAudienceDistributionResult
);
